import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
// import Header from "./Header";

export default function AuthLayout() {
  return (
    <Box sx={{ backgroundColor: "white", width: "100%" }}>
      <Outlet />
    </Box>
  );
}
